export const getMacedoniaData = () => ({
  name: "Macédoine",
  country: "Grèce",
  description: "La Macédoine est la principale région viticole du nord de la Grèce, produisant des vins rouges puissants et des vins blancs aromatiques dans un climat continental.",
  type: "region",
  subregions: [
    { name: "Naoussa", area: "6,000 ha", percentage: "27%", description: "Vins rouges de Xinomavro" },
    { name: "Amyntaio", area: "4,000 ha", percentage: "18%", description: "Vins de montagne" },
    { name: "Goumenissa", area: "3,000 ha", percentage: "14%", description: "Vins d'assemblage" },
    { name: "Halkidiki", area: "5,000 ha", percentage: "23%", description: "Vins de la péninsule" },
    { name: "Autres", area: "4,000 ha", percentage: "18%", description: "Régions diverses" }
  ],
  mapAreas: [
    { region: "Naoussa", x: 54, y: 32, color: "#4B164C", size: 5 },
    { region: "Amyntaio", x: 56, y: 34, color: "#6d2c7a", size: 4 },
    { region: "Goumenissa", x: 55, y: 36, color: "#8a4a8a", size: 3 },
    { region: "Halkidiki", x: 58, y: 38, color: "#a768a6", size: 4 }
  ],
  statistics: {
    totalArea: "22,000 ha",
    production: "300,000 hectolitres",
    wineries: "60+ domaines",
    appellations: "5 sous-régions",
    exportPercentage: "30%"
  },
  characteristics: {
    climate: "Climat continental avec de grandes amplitudes thermiques",
    soil: "Sols calcaires, argilo-calcaires et schisteux",
    viticulture: "Vignes en altitude (200-800m), vendanges tardives"
  },
  wineStyles: {
    red: "Vins rouges puissants et structurés, avec des tannins fermes",
    white: "Vins blancs aromatiques et équilibrés",
    rosé: "Rosés fruités et frais"
  },
  history: "La viticulture macédonienne remonte à l'époque d'Alexandre le Grand. La région a développé une tradition viticole unique, combinant influences balkaniques et méditerranéennes.",
  foodPairing: "Cuisine macédonienne traditionnelle, viandes grillées, fromages affinés"
}); 